import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ReducersTypes } from "@/redux/reducers/Models";
import RegisterPinView from "./view";
import { sendPinRegister, setCustomer } from "@/redux/ducks/customer";
import usePinForm from "../hooks/usePinForm";


export default function RegisterPin() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const customer = useSelector((state: ReducersTypes & {
    userReducer: {
      pin: string;
    }
  }) => state.customerReducer);
  const TIME_AGAIN = 1000;

  const { id } = useParams();

  const {
      toggleModal,
      isVisibleModal,
      isLoading: isLoadingForm,
      isDisabled,
      error,
      register,
      handleSubmit,
      errors,
  } = usePinForm(navigate);

  const [isLoading, setIsLoading] = useState(false);
  const [timer, setTimer] = useState(30);
  const [pinAgain, setPinAgain] = useState(false);

  const goBack = () => navigate(-1);

  const goToLogin = () => navigate("/?auth=true");

  const handleSendPin = () => {
    if (isLoading) return;
    
    setIsLoading(true);
    
    dispatch(
      sendPinRegister({
        document: customer?.register?.document!,
        phone: id === "phone" ? customer?.register?.phone! : undefined,
        email: id === "email" ? customer?.register?.email! : undefined,
        name: customer?.register?.name!,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        callback: _ => {
          setIsLoading(false);
        }
      })
    );
  };

  const handleTryAgain = () => {
    if (timer !== 0 || isLoading) return;
    setIsLoading(true);
    setTimer(30);
    handleSendPin();
  }

  const updateCount = useCallback(() => {
    if (timer > 0) {
      setTimeout(() => {
        setTimer(timer - 1);
      }, TIME_AGAIN);
    }
  }, [timer]);

  useEffect(() => {
    if (timer !== 0) {
      updateCount();
      if (!pinAgain) setPinAgain(true);
    } else if (pinAgain) setPinAgain(false);
  }, [timer, setPinAgain, updateCount]);

  useEffect(() => {
    dispatch(setCustomer({register: {
      ...customer?.register,
      pin: "",
      hashCode: "",
    } }));
    handleSendPin();
    updateCount();
  }, []);

  return (
    <RegisterPinView 
      handleTryAgain={handleTryAgain}
      timer={timer}
      isLoading={isLoading || isLoadingForm}
      handleSubmit={handleSubmit}
      goBack={goBack}
      isDisabled={isDisabled}
      isVisibleModal={isVisibleModal}
      toggleModal={toggleModal}
      goToLogin={goToLogin}
      isEmail={id === "email"}
      register={register}
      errors={errors}
      error={error}
    />
  );
}
